<template>
  <div>
    <!--弹出框-->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      style="height: 100%"
    >
      <el-dialog
        title="水科院预警信息"
        :visible.sync="dialogVisible"
        :modal="false"
        v-dialogDrag
        :before-close="handleClose"
        :close-on-click-modal="false"
        :show-close="true"
        :close-on-press-escape="false"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item type="type" label="标题" prop="title">
              <el-input
                type="type"
                placeholder="标题"
                class="from-el-input"
                v-model.trim="ruleForm.title"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item type="type" label="预警日期" prop="releaseDate">
              <!-- <el-input
                type="type"
                placeholder="期数"
                class="from-el-input"
                v-model.trim="ruleForm.period"
              ></el-input> -->
              <el-date-picker
                  v-model="ruleForm.releaseDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24">
            <el-form-item type="type" label="内容" prop="content">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="内容"
                class="from-el-input"
                v-model.trim="ruleForm.content"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="24" class="col-class">
            <div class="titna">
              <span class="">雨量覆盖图</span>
            </div>
            <div class="tp">
              <el-upload
                action
                :auto-upload="false"
                list-type="picture-card"
                :on-preview="imghandl1"
                :on-change="imgchanges1"
                :on-remove="imghandleRemove1"
                :limit="1"
              >
              </el-upload>
              <!-- <div class='fujian fujians' v-if="ImgfileListData1.length!=0">
									<ul class="fjhxlist">
										<li v-for="(item,i) in ImgfileListData1" :key="i">
											<div class="names cz">
												<el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
												<el-button type="success" icon="el-icon-delete" circle @click="deletesfile(i,item)" class="btnmargin"></el-button>
											</div>
										</li>
									</ul>
								</div> -->
            </div>
            <!-- <div class="tp tps" v-if="ImgfileListData1.length!=0">
								<ul class="qrtpul">
									<li class v-for="(item,i) in ImgfileListData1" :key="i">
										<img :src="item.url" alt style="width:20%; cursor: pointer; float: left;" @click="imgzoom(item.url)" />
									</li>
								</ul>
							</div> -->
          </el-col>
        </el-row>
        <el-row class="rowTop" style="margin-top: 10px;">
          <el-col :span="24">
            <div class="titna">
              <span class="addSpan">附件</span>
            </div>
            <div class="fujian">
              <el-upload
                class="upload-demo"
                drag
                action=""
                multiple
                :on-remove="handleRemove"
                :on-change="changes"
                :file-list="fileList"
                :limit="1"
                :auto-upload="false"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
              <!-- <div class='fujian fujians' v-if="filetabledata.length!=0">
									<ul class="fjhxlist">
										<li v-for="(item,i) in filetabledata" :key="i">
											<div class="names" style="text-align: left;">{{item.sourceName}}</div>
											<div class="names cz">
												<el-button type="primary" icon="el-icon-view" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
												<el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfilesss(i,item)"
													class="btnmargin"></el-button>
											</div>
										</li>
									</ul>
								</div> -->
            </div>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button round @click="cancel()" type="warning">取消</el-button>
            <el-button round type="primary" @click="deteRmine('ruleForm')"
              >保 存</el-button
            >
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
    <el-dialog :visible.sync="imgdialogVisible">
      <img width="90%" height="90%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { saveSkyTempWarn } from "@/api/api";
import axios from "axios";

export default {
  props: {
    mystate: Array
  },
  data() {
    return {
      // downloadUrl: "/userApi/minio/downloadFile/",
      urlsss: "/userApi/minio/updateFileMulti/",
      dialogVisible: true,
      state: "",
      ruleForm: {
        title: "",
        //period: "",
        content: "",
        releaseDate: ""
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur"
          }
        ],
        // period: [
        //   {
        //     required: true,
        //     message: "请输入必填项",
        //     trigger: "blur"
        //   }
        // ],
        releaseDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入必填项",
            trigger: "blur"
          }
        ]
      },
      fileList: [], // 附件
      filetabledata: [], // 回显附件
      fileUrl: "",
      fileList1: [], // 修复前图片提交
      ImgfileListData1: [], // 修复前图片回显
      fileUrl1: "",
      row: null,
      dialogImageUrl: "",
      imgdialogVisible: false
    };
  },
  created() {
    //初始化数据
  },
  methods: {
    cancel() {
      this.fileUrl = "";
      this.fileUrl1 = "";
      this.dialogVisible = false;
      this.$emit("getcancel", {
        dialogVisible: this.dialogVisible
      });
    },
    imghandl1(file) {
      this.dialogImageUrl = file.url;
      this.imgdialogVisible = true;
    },
    imgchanges1(file, fileList) {
      let num = 1024.0;
      if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
        fileList.splice(fileList.length - 1, 1);
        this.$message.error("选择文件大于10M，请重新选择！");
      } else {
        this.fileList1.push(file.raw);
      }
    },
    imghandleRemove1(file, fileList) {
      console.log("=======", file, fileList);
      // 删除文件
      for (let i = 0; i < this.fileList1.length; i++) {
        if (file.name == this.fileList1[i].name) {
          this.fileList1.splice(this.fileList1[i], 1);
        }
      }
    },
    DownloadFile(index, row) {
      console.log(row);
      // 下载文件
      window.open(url);
    },
    imgzoom(url) {
      window.open(url);
    },
    deletesfile(index, row, type) {
      // 删除文件
      console.log(index, row, type);
      // let params = {id:row.id, fileName:row.fileName};
      // deleteFile(params).then((res) => {
      // 	if(res.code == 200) {
      // 		this.$notify({
      // 			title: '',
      // 			message: res.message,
      // 			type: 'success'
      // 		});
      //     if(type === 'xfq') this.ImgfileListData1.splice(index, 1);
      //     if(type === 'xfh') this.ImgfileListData2.splice(index, 1);
      //     if (type === 'fujian') {
      //       this.filetabledata.splice(index, 1);
      //     }
      // 	}
      // })
    },
    handleRemove(file, fileList) {
      // 删除文件
      for (let i = 0; i < this.fileList.length; i++) {
        if (file.name == this.fileList[i].name) {
          this.fileList.splice(this.fileList[i], 1);
        }
      }
    },
    changes(file, fileList) {
      let num = 1024.0;
      if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
        fileList.splice(fileList.length - 1, 1);
        this.$message.error("选择文件大于10M，请重新选择！");
      } else {
        this.fileList.push(file.raw);
      }
    },
    // deteRmine(formName) {
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       let config = {
    //         headers: {
    //           "Content-Type": "multipart/form-data",
		// 					"Access-Token": this.$store.state.token
    //         }
    //       }; // 添加请求头
    //       //应急响应流程图Url
    //       if (this.fileList1.length != 0) {
    //         let formData1 = new FormData();
    //         this.fileList1.forEach((el, index) => {
    //           formData1.append("file", el); // 'file' 可变 相当于 input 表单的name 属性
    //         });
    //         axios
    //           .post(this.urlsss, formData1, config)
    //           .then(res => {
    //             if (res.data.code === 200) {
    //               this.fileUrl1 = res.data.data;
    //             }
    //           })
    //           .catch(err => {});
    //       }
					
    //       //附件Url
    //       if (this.fileList.length != 0) {
    //         let formData = new FormData();
    //         this.fileList.forEach((el, index) => {
    //           formData.append("file", el); // 'file' 可变 相当于 input 表单的name 属性
    //         });
    //         axios
    //           .post(this.urlsss, formData, config)
    //           .then(res => {
    //             if (res.data.code === 200) {
    //               this.fileUrl = res.data.data;
    //             }
    //           })
    //           .catch(err => {});
    //       }
    //     }
		// 		console.log(this.fileUrl1);
    //     let _this = this;
    //     setTimeout(function() {
    //       const releaseDate = this.ruleForm.releaseDate;
    //       if(_this.fileUrl1.length == 0 || _this.fileUrl.length == 0){
    //         _this.$notify({
    //             title: "提示",
    //             message: '请上传图片',
    //             type: "warning"
    //           });
		// 				return
		// 			}
		// 			if(_this.fileUrl.length == 0) {
    //         _this.$notify({
    //             title: "提示",
    //             message: '请上传表格',
    //             type: "warning"
    //           });
		// 				return
		// 			}
    //       let params = {
		// 				title: _this.ruleForm.title,
		// 				//period: _this.ruleForm.period,
    //         releaseDate: this.ruleForm.releaseDate,
		// 				content: _this.ruleForm.content,
    //         pcFile: _this.fileUrl1,
    //         excelFile: _this.fileUrl,
    //       };
    //       saveSkyTempWarn(params).then((res) => {
    //         if (res.code === 200) {
		// 					let config = {
		// 						headers: {
		// 							"Content-Type": "multipart/form-data",
		// 							"Access-Token": _this.$store.state.token
		// 						}
		// 					}; // 添加请求头
		// 					let formData1 = new FormData();
		// 					_this.fileList.forEach((el, index) => {
		// 						formData1.append("file", el); // 'file' 可变 相当于 input 表单的name 属性
		// 					});
		// 					formData1.append('id',res.data)
		// 					axios
		// 						.post("/userApi/ydb/skyWarn/importSkyYdbInfo", formData1, config)
		// 						.then(res => {
		// 						}).catch(err => {});
    //           _this.$notify({
    //             title: "提示",
    //             message: "提交成功",
    //             type: "success"
    //           });
    //           _this.dialogVisible = false;
    //           _this.$emit("adddata", {
    //             dialogVisible: _this.dialogVisible
    //           });
    //         } else {
    //           _this.$notify({
    //             title: "提示",
    //             message: res.message,
    //             type: "warning"
    //           });
    //         }
    //       })
    //     }, 8000);
    //   });
    // },

    deteRmine(formName) {
  this.$refs[formName].validate(valid => {
    if (!valid) {
      this.$notify({
        title: "提示",
        message: "请填写所有必填项",
        type: "warning"
      });
      return;
    }

    // 添加空值检查
    if (!this.ruleForm || !this.ruleForm.releaseDate) {
      this.$notify({
        title: "提示",
        message: "请选择日期",
        type: "warning"
      });
      return;
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Token": this.$store.state.token
      }
    };

    // 使用原始日期字符串
    const releaseDate = this.ruleForm.releaseDate;

    // 检查文件是否已选择
    if (this.fileList1.length === 0 || this.fileList.length === 0) {
      this.$notify({
        title: "提示",
        message: this.fileList1.length === 0 ? '请上传图片' : '请上传表格',
        type: "warning"
      });
      return;
    }

    // 使用Promise.all并行上传文件
    Promise.all([
      this.uploadFiles(this.fileList1, config),
      this.uploadFiles(this.fileList, config)
    ]).then(([fileUrl1, fileUrl]) => {
      if (!fileUrl1 || !fileUrl) {
        throw new Error(!fileUrl1 ? '图片上传失败' : '表格上传失败');
      }

      return saveSkyTempWarn({
        title: this.ruleForm.title,
        releaseDate: releaseDate,
        content: this.ruleForm.content,
        pcFile: fileUrl1,
        excelFile: fileUrl
      });
    }).then(res => {
      if (res.code === 200) {
        return this.importData(res.data, config);
      } else {
        throw new Error(res.message || '保存失败');
      }
    }).then(() => {
      this.$notify({
        title: "提示",
        message: "提交成功",
        type: "success"
      });
      this.dialogVisible = false;
      this.$emit("adddata", {
        dialogVisible: this.dialogVisible
      });
    }).catch(err => {
      console.error('提交失败:', err);
      this.$notify({
        title: "提示",
        message: err.message || '提交失败',
        type: "error"
      });
    });
  });
},

// 新增上传文件封装方法
uploadFiles(files, config) {
  if (files.length === 0) return Promise.resolve('');
  
  const formData = new FormData();
  files.forEach(file => formData.append("file", file));
  
  return axios.post(this.urlsss, formData, config)
    .then(res => res.data.code === 200 ? res.data.data : '')
    .catch(() => '');
},

// 新增导入数据封装方法
importData(id, config) {
  const formData = new FormData();
  this.fileList.forEach(file => formData.append("file", file));
  formData.append('id', id);
  
  return axios.post("/userApi/ydb/skyWarn/importSkyYdbInfo", formData, config);
},
    handleClose() {
      this.dialogVisible = false;
      this.$emit("getcancel", {
        dialogVisible: this.dialogVisible
      });
    }
  },
  mounted() {}
};
</script>

<style scoped="scoped">
>>> .el-dialog {
  width: 800px;
}

>>> .el-dialog__body {
  height: 450px;
  overflow: auto;
}

.treebox {
  width: 100%;
  margin: 0;
}

.trees {
  width: 98%;
  float: left;
  max-height: 300px;
  height: 60px;
  line-height: 30px;
  padding-left: 2%;
  margin-top: 5px;
}
.fujian {
  width: calc(100% - 112px);
  width: -webkit-calc(100% - 112px);
  width: -moz-calc(100% - 112px);
  float: right;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  overflow: auto;
}
.tp {
  width: calc(100% - 132px);
  float: right;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
}
</style>
